export default __webpack_public_path__ + "static/media/upload.d5161e38.svg";